import React from "react";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/core/styles";
import { translate } from "react-i18next";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import DateRangeIcon from "@material-ui/icons/DateRange";
import Button from "@material-ui/core/Button";
import Picker from "rc-calendar/lib/Picker";
import RangeCalendar from "rc-calendar/lib/RangeCalendar";
import "rc-calendar/assets/index.css";
import moment from "moment";
import Input from "@material-ui/core/Input";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import ListItemText from "@material-ui/core/ListItemText";
import Select from "@material-ui/core/Select";
import Checkbox from "@material-ui/core/Checkbox";
import PropTypes from "prop-types";
import NumberFormat from "react-number-format";

import { campaignService } from "../_services";
import { alertActions, campaignActions } from "../_actions";
import Campaign from "../_helpers/campaign";
import "./AddCampaignPage.css";
import {
    CAMPAIGN_STATE,
    THEME,
    DATE_FORMAT,
    calculateExpectedImpressions
} from "../_constants";
import UploadBannerComponent from "./UploadBannerComponent";
import TimeSlotsComponent from "./TimeSlotsComponent";

const styles = theme => ({
    container: {
        backgroundColor: "white",
        position: "fixed",
        top: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        flexBasis: "row",
        overflow: "auto"
    },
    formArea: {
        width: 600
    },
    heading: {
        fontSize: theme.typography.pxToRem(25),
        marginTop: 30,
        marginLeft: 70
    },
    form: {
        width: 450,
        margin: "auto",
        marginTop: 50,
        padding: 0,
        display: "flex",
        flexDirection: "column"
    },
    leftArea: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center"
    },
    field: {
        marginTop: 10,
        marginBottom: 10,
        alignSelf: "center",
        alignItems: "center",
        width: "90%",
        display: "flex",
        flexDirection: "row"
    },
    textfield: {
        marginBottom: 10,
        alignSelf: "center",
        width: "90%"
    },
    button: {
        width: "100%",
        margin: 0,
        padding: 10,
        textTransform: "none"
    },
    rightIcon: {
        marginLeft: "auto",
        marginRight: 0
    },
    submitButtonsArea: {
        marginTop: 10,
        display: "flex",
        flexDirection: "row-reverse"
    },
    submitButton: {
        margin: 10,
        width: 150,
        padding: 15
    },
    formControl: {
        alignSelf: "center",
        width: "90%",
        margin: theme.spacing.unit,
        minWidth: "90%",
        maxWidth: "90%"
    },
    costPerDisplay: {
        width: "90%",
        margin: 15,
        alignSelf: "center"
    },
    summaryArea: {
        backgroundColor: THEME.COLOR.MAIN,
        width: 400,
        paddingTop: 130,
        paddingLeft: 35,
        paddingRight: 35
    },
    summaryGroup: {
        marginTop: 15,
        marginBottom: 15
    },
    infoItem: {
        display: "flex",
        flexDirection: "row",
        alignItems: "baseline"
    },
    infoItem_title: {
        flexBasis: 150,
        color: THEME.COLOR.GRAY
    },
    infoItem_value: {
        flex: 1,
        color: THEME.COLOR.GRAY
    }
});

//#region Select Menu
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 250
        }
    }
};
//#endregion Select Menu

//#region DateTime Helper
const now = moment();

function newArray(start, end) {
    const result = [];
    for (let i = start; i < end; i++) {
        result.push(i);
    }
    return result;
}

function disabledTime(time, type) {
    if (type === "start") {
        return {
            disabledHours() {
                const hours = newArray(0, 60);
                hours.splice(20, 4);
                return hours;
            },
            disabledMinutes(h) {
                if (h === 20) {
                    return newArray(0, 31);
                } else if (h === 23) {
                    return newArray(30, 60);
                }
                return [];
            },
            disabledSeconds() {
                return [55, 56];
            }
        };
    }
    return {
        disabledHours() {
            const hours = newArray(0, 60);
            hours.splice(2, 6);
            return hours;
        },
        disabledMinutes(h) {
            if (h === 20) {
                return newArray(0, 31);
            } else if (h === 23) {
                return newArray(30, 60);
            }
            return [];
        },
        disabledSeconds() {
            return [55, 56];
        }
    };
}
//#endregion DateTime Helper

//#region format number
function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;

    return (
        <NumberFormat
            {...other}
            ref={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        value: values.value
                    }
                });
            }}
            thousandSeparator="."
            decimalSeparator=","
        />
    );
}

NumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired
};
//#endregion format number

class AddCampaignPage extends React.Component {
    costPerDisplay = 1000;

    //#region life cycle
    constructor(props) {
        super(props);

        function getStateFromCampaign(campaign, districts) {
            let state = null;

            if (campaign) {
                let selectedDateRange = [
                    moment(campaign.startDate, DATE_FORMAT),
                    moment(campaign.endDate, DATE_FORMAT)
                ];
                let selectedDistricts = campaign.zones.map(district => {
                    let dist = districts.find(item => item.id === district.id);

                    let newDistrictObj = {
                        id: district.id,
                        name: district.name,
                        code: dist ? dist.code : null
                    };

                    return newDistrictObj;
                });
                let selectedDisplayTimes = campaign.params.timeSlots.slice();
                let numberOfDisplays = campaign.needDisplay
                    ? campaign.needDisplay
                    : 0;
                let campaignBudget = campaign.budget ? campaign.budget : 0;
                let impression = campaign.impression ? campaign.impression : 0;

                state = {
                    campaignName: campaign.name,
                    selectedDateRange: selectedDateRange,
                    selectedDistricts: selectedDistricts,
                    selectedDisplayTimes: selectedDisplayTimes,
                    numberOfDisplays: numberOfDisplays,
                    campaignBudget: campaignBudget,
                    impression: impression
                };
            } else {
                state = {
                    selectedDateRange: [],
                    hoverDateValue: [],
                    selectedDistricts: [],
                    selectedDisplayTimes: [],
                    numberOfDisplays: 0,
                    campaignBudget: 0,
                    impression: 0
                };
            }

            return state;
        }

        this.state = getStateFromCampaign(props.campaign, props.districts);

        this.uploadBannerComponent = React.createRef();
        this.updateCampaign = this.updateCampaign.bind(this);
    }

    componentWillMount() {
        this.updateDimensions();
    }

    componentDidMount() {
        window.addEventListener("resize", this.updateDimensions.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    }
    //#endregion life cycle

    //#region actions
    updateDimensions() {
        const height = window.innerHeight;
        this.setState({ height: height });
    }

    handleChangeCampaignName = name => event => {
        this.setState({
            [name]: event.target.value
        });
    };

    handleChangeNumberOfDisplays = name => event => {
        const re = /^[0-9\b]+$/;

        // if value is not blank, then test the regex
        if (event.target.value === "" || re.test(event.target.value)) {
            let numbDisplays = event.target.value;
            let campaignBudget = numbDisplays * this.costPerDisplay;
            let isOverCost = campaignBudget > this.props.balance;
            this.setState({
                numberOfDisplays: numbDisplays,
                campaignBudget: campaignBudget,
                isOverCost: isOverCost,
                impression: calculateExpectedImpressions(numbDisplays)
            });
        }
    };

    onChangeSelectedDateRange = selectedDateRange => {
        this.setState({ selectedDateRange });
    };

    onHoverChangeDate = hoverDateValue => {
        this.setState({ hoverDateValue });
    };

    handleChangeDistricts = event => {
        let selectedDistrictObjs = event.target.value.map(name => {
            let districtObj = this.props.districts.find(
                item => item.name === name
            );

            return districtObj;
        });
        this.setState({ selectedDistricts: selectedDistrictObjs });
    };

    handleUpdateTimeSlots = timeSlots => {
        this.setState({ selectedDisplayTimes: timeSlots });
    };

    updateCampaign(campaignState) {
        const _state = this.state;
        const self = this;

        function getZonesObjFromZoneArray(zoneArr) {
            let zonesObj = {};
            zoneArr.map(district => {
                zonesObj[district.code] = {
                    id: district.id,
                    name: district.name,
                    inMoney: 7000,
                    outMoney: 500
                };

                return district;
            });

            return zonesObj;
        }

        function normalizeTimeSlotsWithZones(timeSlots, zonesObj) {
            let normalizedTimeSlots = timeSlots.map(timeSlot => ({
                start: timeSlot.start,
                end: timeSlot.end,
                zones: zonesObj
            }));

            return normalizedTimeSlots;
        }

        function createCampaignObj() {
            let campaign = {};

            let uploadItems = self.uploadBannerComponent.getUploadedItems();
            campaign = { ...campaign, ...uploadItems };

            campaign.name = _state.campaignName;
            campaign.startDate = _state.selectedDateRange[0].format(
                DATE_FORMAT
            );
            campaign.endDate = _state.selectedDateRange[1].format(DATE_FORMAT);
            campaign.state = campaignState;
            campaign.needDisplay = Number(_state.numberOfDisplays);
            campaign.budget = _state.campaignBudget;
            campaign.impression = _state.impression;

            let zonesObj = getZonesObjFromZoneArray(_state.selectedDistricts);
            let timeSlots = normalizeTimeSlotsWithZones(
                _state.selectedDisplayTimes,
                zonesObj
            );

            campaign.params = {
                timeSlots: timeSlots,
                zones: _state.selectedDistricts
            };

            return campaign;
        }

        function handleUpdateSuccess(campaign) {
            self.props.dispatch(campaignActions.getAll());

            self.props.onUpdate(null, null);
        }

        function handleUpdateFail(error) {
            self.props.dispatch(alertActions.error(error));
        }

        if (this.validate() === false) {
            return;
        }

        if (this.state.isOverCost) {
            const { t } = this.props;
            this.props.dispatch(alertActions.error(t("NotEnoughMoney")));

            return;
        }

        let campaign = createCampaignObj();

        if (self.props.campaign) {
            campaignService
                .updateCampaign(self.props.campaign.id, campaign)
                .then(
                    campaign => handleUpdateSuccess(campaign),
                    error => handleUpdateFail(error)
                );
        } else {
            campaignService
                .createCampaign(campaign)
                .then(
                    campaign => handleUpdateSuccess(campaign),
                    error => handleUpdateFail(error)
                );
        }
    }

    startCampaign(campaign) {
        console.log("hello");
        if (this.validate() === false) {
            return;
        }

        Campaign.startCampaign(campaign, this.props, () =>
            this.props.onDismiss(null, null)
        );
    }

    removeCampaign(campaign) {
        Campaign.removeCampaign(campaign, this.props, () =>
            this.props.onDismiss(null, null)
        );
    }
    //#endregion actions

    //#region validation
    validate() {
        const { t } = this.props;
        let message = "";
        let isValid = this.validateName();

        if (isValid === false) {
            message = t("InvalidCampaignName");
        } else {
            isValid = this.validateDates();

            if (isValid === false) {
                message = t("InvalidCampaignDateRange");
            } else {
                isValid = this.validateZones();

                if (isValid === false) {
                    message = t("InvalidCampaignZones");
                } else {
                    isValid = this.validateTimeSlots_notEmpty();

                    if (isValid === false) {
                        message = t("InvalidTimeSlots_Empty");
                    } else {
                        isValid = this.validateTimeSlots_valid();

                        if (isValid === false) {
                            message = t("InvalidTimeSlots_Invalid");
                        } else {
                            isValid = this.validateDisplayNumber();

                            if (isValid === false) {
                                message = t("InvalidDisplayNumber");
                            } else {
                                isValid = this.validateBanners();

                                if (isValid === false) {
                                    message = t("InvalidBanners");
                                }
                            }
                        }
                    }
                }
            }
        }

        this.props.dispatch(alertActions.error(message));

        return isValid;
    }

    validateName() {
        let isValid = true;

        if (!this.state.campaignName || this.state.campaignName.trim() === "") {
            isValid = false;
        }

        return isValid;
    }

    validateDates() {
        let isValid = true;

        if (
            !this.state.selectedDateRange ||
            this.state.selectedDateRange.length !== 2
        ) {
            isValid = false;
        }

        return isValid;
    }

    validateZones() {
        let isValid = true;

        if (
            !this.state.selectedDistricts ||
            this.state.selectedDistricts.length === 0
        ) {
            isValid = false;
        }

        return isValid;
    }

    validateTimeSlots_notEmpty() {
        let isValid = true;
        if (
            !this.state.selectedDisplayTimes ||
            this.state.selectedDisplayTimes.length === 0 || (this.state.selectedDisplayTimes.length !==0 && this.state.selectedDisplayTimes[this.state.selectedDisplayTimes.length-1].end ===null)
        ) {
            isValid = false;
        }

        return isValid;
    }

    validateTimeSlots_valid() {
        let isValid = true;

        if (
            !this.state.selectedDisplayTimes ||
            this.state.selectedDisplayTimes.length === 0
        ) {
            isValid = false;
        } else {
            let ts = this.state.selectedDisplayTimes.slice();
            // cut out
            if (ts && ts.length > 0) {
                let lastTS = ts[ts.length - 1];
                if (lastTS.start === null && lastTS.end === null) {
                    ts.splice(ts.length - 1, 1);
                }
            }

            //
            let invalidTS = ts.find(
                item => item.start === null || item.end === null
            );

            if (invalidTS) {
                isValid = false;
            }
        }

        return isValid;
    }

    validateDisplayNumber() {
        let isValid = true;

        if (!this.state.numberOfDisplays || this.state.numberOfDisplays < 1) {
            isValid = false;
        }

        return isValid;
    }

    validateBanners() {
        function isEmptyObj(obj) {
            return Object.keys(obj).length === 0 && obj.constructor === Object;
        }

        let isValid = true;

        let uploadItems = this.uploadBannerComponent.getUploadedItems();
        if (
            // TODO: edit conditions
            isEmptyObj(uploadItems.img1) &&
            isEmptyObj(uploadItems.img2) &&
            isEmptyObj(uploadItems.img3) &&
            isEmptyObj(uploadItems.video)
        ) {
            isValid = false;
        }

        return isValid;
    }
    //#endregion validation

    render() {
        const { classes, t, districts, campaign, balance } = this.props;
        const self = this;
        const state = this.state;

        function renderFormArea() {
            function renderInputArea(isEditable) {
                function renderDateRangeInput() {
                    const calendar = (
                        <RangeCalendar
                            hoverValue={state.hoverDateValue}
                            onHoverChange={self.onHoverChangeDate}
                            showWeekNumber={false}
                            dateInputPlaceholder={[t("FromDate"), t("ToDate")]}
                            defaultValue={[now, now.clone().add(1, "months")]}
                            disabledTime={disabledTime}
                        />
                    );

                    function renderDateRange(startDate = null, endDate = null) {
                        function renderCalendarButton(title, action) {
                            return (
                                <Button
                                    variant="outlined"
                                    className={classes.button}
                                >
                                    {title}
                                    <DateRangeIcon
                                        className={classes.rightIcon}
                                    />
                                </Button>
                            );
                        }

                        let fromDateStr =
                            startDate == null
                                ? t("FromDate")
                                : startDate.format(DATE_FORMAT);
                        let toDateStr =
                            endDate == null
                                ? t("ToDate")
                                : endDate.format(DATE_FORMAT);

                        return (
                            <div className={classes.field}>
                                {renderCalendarButton(fromDateStr, null)}
                                <div
                                    style={{
                                        flexBasis: 50,
                                        textAlign: "center"
                                    }}
                                >
                                    -
                                </div>
                                {renderCalendarButton(toDateStr, null)}
                            </div>
                        );
                    }

                    return (
                        <Picker
                            value={state.selectedDateRange}
                            onChange={self.onChangeSelectedDateRange}
                            animation="slide-up"
                            calendar={calendar}
                        >
                            {({ value }) => {
                                return renderDateRange(value[0], value[1]);
                            }}
                        </Picker>
                    );
                }

                function renderDropdownButton(
                    title,
                    dataSource,
                    selectedValues,
                    onChange
                ) {
                    return (
                        <FormControl className={classes.formControl}>
                            <InputLabel htmlFor="select-multiple-checkbox">
                                {title}
                            </InputLabel>
                            <Select
                                multiple
                                value={selectedValues}
                                onChange={onChange}
                                input={<Input id="select-multiple-checkbox" />}
                                renderValue={selected => selected.join(", ")}
                                MenuProps={MenuProps}
                            >
                                {dataSource.map((item, index) => {
                                    let isSelected =
                                        selectedValues.indexOf(item) > -1;
                                    return (
                                        <MenuItem key={index} value={item}>
                                            <Checkbox checked={isSelected} />
                                            <ListItemText primary={item} />
                                        </MenuItem>
                                    );
                                })}
                            </Select>
                        </FormControl>
                    );
                }

                function renderCostPerDisplay() {
                    return (
                        <i className={classes.costPerDisplay}>
                            <NumberFormat
                                value={self.costPerDisplay}
                                displayType={"text"}
                                thousandSeparator={"."}
                                decimalSeparator={","}
                                suffix={" đ/lượt"}
                                renderText={value => (
                                    <Typography>{value}</Typography>
                                )}
                            />
                        </i>
                    );
                }

                return (
                    <div className={classes.leftArea}>
                        <TextField
                            className={classes.textfield}
                            id="campaignName"
                            label={t("CampaignName")}
                            margin="normal"
                            value={state.campaignName}
                            onChange={self.handleChangeCampaignName(
                                "campaignName"
                            )}
                        />
                        {renderDateRangeInput()}
                        {renderDropdownButton(
                            t("Zone"),
                            districts.map(item => item.name),
                            state.selectedDistricts.map(item => item.name),
                            self.handleChangeDistricts
                        )}
                        <TimeSlotsComponent
                            value={state.selectedDisplayTimes}
                            emptyTimeSlot={self.props.emptyTimeSlot}
                            onUpdateTimeSlots={timeSlots =>
                                self.handleUpdateTimeSlots(timeSlots)
                            }
                        />
                        <TextField
                            className={classes.textfield}
                            id="numberOfDisplays"
                            label={t("Displays")}
                            margin="normal"
                            value={state.numberOfDisplays}
                            onChange={self.handleChangeNumberOfDisplays(
                                "numberOfDisplays"
                            )}
                            InputProps={{
                                inputComponent: NumberFormatCustom
                            }}
                        />
                        {renderCostPerDisplay()}
                        {/* {isEditable ? null : (
                            <div
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    bottom: 0,
                                    right: 0,
                                    backgroundColor: "rgba(255, 0, 0, 0.2)"
                                }}
                            />
                        )} */}
                    </div>
                );
            }

            function renderImageUploadArea(isEditable) {
                let mediaData = null;

                if (campaign) {
                    let { img1, img2, img3, video } = campaign;
                    mediaData = { img1, img2, img3, video };
                }

                return (
                    <div>
                        <UploadBannerComponent
                            className={classes.uploadArea}
                            mediaData={mediaData}
                            innerRef={el => {
                                self.uploadBannerComponent = el;
                            }}
                        />
                        {/* {isEditable ? null : (
                            <div
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    bottom: 0,
                                    right: 0,
                                    backgroundColor: "rgba(255, 0, 0, 0.2)"
                                }}
                            />
                        )} */}
                    </div>
                );
            }

            function renderButtonArea(isEditable) {
                function renderSubmitButton(title, type, action) {
                    return (
                        <Button
                            className={classes.submitButton}
                            variant="raised"
                            color={type}
                            onClick={action}
                        >
                            {title}
                        </Button>
                    );
                }

                function renderDraftSubmitBtns() {
                    return (
                        <div className={classes.submitButtonsArea}>
                            {renderSubmitButton(
                                t("SubmitDraftCampaign"),
                                "primary",
                                () =>
                                    self.updateCampaign(
                                        CAMPAIGN_STATE.TOBEREVIEWED.value
                                    )
                            )}
                            {renderSubmitButton(t("SaveDraft"), "default", () =>
                                self.updateCampaign(
                                    CAMPAIGN_STATE.DRAFTED.value
                                )
                            )}
                        </div>
                    );
                }

                function renderCancelStartBtns() {
                    return (
                        <div className={classes.submitButtonsArea}>
                            {renderSubmitButton(
                                t("CampaignState_ToBeStarted"),
                                "primary",
                                () => self.startCampaign(campaign)
                            )}
                            {renderSubmitButton(t("Cancel"), "default", () =>
                                self.removeCampaign(campaign)
                            )}
                        </div>
                    );
                }

                return isEditable
                    ? renderDraftSubmitBtns()
                    : renderCancelStartBtns();
            }

            let isEditable =
                !campaign || campaign.state !== CAMPAIGN_STATE.APPROVED.value;
            let title = campaign
                ? isEditable
                    ? t("Edit")
                    : t("Approved")
                : t("AddCampaign");

            return (
                <div
                    className={classes.formArea}
                    style={{
                        maxHeight: state.height,
                        overflow: "auto"
                    }}
                >
                    <Typography variant="title" className={classes.heading}>
                        {title}
                    </Typography>
                    <form
                        className={classes.form}
                        name="form"
                        noValidate
                        autoComplete="off"
                    >
                        {/* <fieldset disabled> */}
                        {/* <div
                            style={{
                                backgroundColor: "rgba(0, 255, 0, 0.2)"
                            }}
                        > */}
                        {renderInputArea(isEditable)}
                        {renderImageUploadArea(isEditable)}
                        {/* {isEditable ? null : (
                                <div
                                    style={{
                                        // margin: 0,
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        bottom: 0,
                                        right: 0,
                                        backgroundColor: "transparent"
                                    }}
                                />
                            )} */}
                        {renderButtonArea(isEditable)}
                        {/* </div> */}
                        {/* </fieldset> */}
                    </form>
                </div>
            );
        }

        function renderSummaryArea() {
            const FORMAT = { TEXT: 0, NUMBER: 1, MONEY: 2 };

            function renderInfo(
                title,
                value,
                format = FORMAT.TEXT,
                color = null
            ) {
                return (
                    <div className={classes.infoItem}>
                        <Typography
                            variant="body2"
                            className={classes.infoItem_title}
                        >
                            {title}:
                        </Typography>
                        {format === FORMAT.TEXT ? (
                            <Typography
                                className={classes.infoItem_value}
                                style={color ? { color: color } : {}}
                            >
                                {value}
                            </Typography>
                        ) : (
                            <NumberFormat
                                value={value}
                                displayType={"text"}
                                thousandSeparator={"."}
                                decimalSeparator={","}
                                suffix={format === FORMAT.MONEY ? " đ" : ""}
                                renderText={value => (
                                    <Typography
                                        className={classes.infoItem_value}
                                        style={color ? { color: color } : {}}
                                    >
                                        {value}
                                    </Typography>
                                )}
                            />
                        )}
                    </div>
                );
            }

            function renderInfoArray(title, values) {
                return (
                    <div className={classes.infoItem}>
                        <Typography
                            variant="body2"
                            className={classes.infoItem_title}
                        >
                            {title}:
                        </Typography>
                        <div className={classes.infoItem_value}>
                            {values.map((value, index) => (
                                <Typography
                                    key={index}
                                    className={classes.infoItem_value}
                                >
                                    {value}
                                </Typography>
                            ))}
                        </div>
                    </div>
                );
            }

            return (
                <div className={classes.summaryArea}>
                    <div className={classes.summaryGroup}>
                        {renderInfo(
                            t("Timer"),
                            (state.selectedDateRange[0]
                                ? state.selectedDateRange[0].format(DATE_FORMAT)
                                : "") +
                                " - " +
                                (state.selectedDateRange[1]
                                    ? state.selectedDateRange[1].format(
                                          DATE_FORMAT
                                      )
                                    : ""),
                            FORMAT.TEXT
                        )}
                        {renderInfoArray(
                            t("RangeTime"),
                            state.selectedDisplayTimes.map(
                                item =>
                                    (item.start ? item.start : "") +
                                    " - " +
                                    (item.end ? item.end : "")
                            )
                        )}
                        {renderInfoArray(
                            t("Zone"),
                            state.selectedDistricts.map(item => item.name)
                        )}
                        {renderInfo(
                            t("Displays"),
                            state.numberOfDisplays,
                            FORMAT.NUMBER
                        )}
                    </div>
                    <div className={classes.summaryGroup}>
                        {renderInfo(
                            t("Cost"),
                            state.campaignBudget,
                            FORMAT.MONEY,
                            state.isOverCost ? "red" : null
                        )}
                        {renderInfo(
                            t("Balance"),
                            balance,
                            FORMAT.MONEY,
                            state.isOverCost ? "red" : null
                        )}
                    </div>
                    <div className={classes.summaryGroup}>
                        {renderInfo(
                            t("ExpectedImpressions"),
                            state.impression,
                            FORMAT.NUMBER
                        )}
                    </div>
                </div>
            );
        }

        return (
            <div className={classes.container}>
                {renderFormArea()}
                {renderSummaryArea()}
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { districts } = state.location;

    return {
        districts,
        balance: state.authentication.user.balance
    };
}

const styleComponent = withStyles(styles)(
    translate("translations")(AddCampaignPage)
);
const connectedComponent = connect(mapStateToProps)(styleComponent);
export { connectedComponent as AddCampaignPage };



// WEBPACK FOOTER //
// ./src/AddCampaignPage/AddCampaignPage.js